import { INotification } from '../models/INotification';
import { Notification } from './Notification';
import { StyledNotificationContainer } from './NotificationContainer.styles';

export const NotificationContainer = ({
  notifications,
}: {
  notifications: INotification[];
}) => {
  return (
    <StyledNotificationContainer>
      {notifications.map((notification, index) => (
        <Notification key={index} notification={notification} />
      ))}
    </StyledNotificationContainer>
  );
};
